@if (sections.includes('report')) {
    <key-form-builder
        [ownerId]="clientId"
        [inline]="!isMobile"
        [form]="reportForm"
        [values]="reportValues"></key-form-builder>
}

@if (sections.includes('parameters')) {
    <key-form-builder class="pt-2"
        [ownerId]="clientId"
        [inline]="!isMobile"
        [form]="parametersForm"
        [values]="parameterValues"></key-form-builder>
}

@if (hasLayout && sections.includes('layout')) {
    <div>
        <key-form-builder [inline]="!isMobile"
            [ownerId]="clientId"
            [form]="layoutForm"
            [values]="layoutFormValues"></key-form-builder>

        @if (columns && columns.length > 0) {
            <div class="form-group"
                [class.inline]="!isMobile"
                [class.hidden]="layoutForm?.groups[0]?.visible === false || layoutForm?.groups[0]?.collapsed === true">
                <label class='form-label'>{{ 'REPORTING.BUILDER.FORMS.COLUMNS' | translate }}</label>
                <div class="form-field">
                    <key-reporting-builder-columns [columns]="columns"
                        [availableColumns]="reportDefinition.layout.columns"
                        [autoColumns]="reportDefinition.layout.autoColumns"
                        (onUpdateColumns)="columns = $event"
                        class="text-left"></key-reporting-builder-columns>
                </div>
            </div>
        }
    </div>
}
